import * as React from 'react';
import classNames from 'classnames';
import { isFunction } from 'lodash';

import IMPComponent from '../interfaces/IMPComponent';
import { Modifiers } from 'react-day-picker';

import './styles.scss';
import { COMMON_CONSTANTS } from '../../constants/common';
import posed from 'react-pose';

export interface IDayTileProps {
  expectedWordsCount: number;
  actualWordsCount?: number;
  day: number | string;
  isCurrent?: boolean;
  isSelected?: boolean;
  isPast?: boolean;
  isStreakRepaired?: boolean;
  value: Date;
  onClick?: (data: Date) => void;
  modifiers: Modifiers;
}

const Box = posed.div({
  hoverable: true,
  pressable: true,
  init: {
    scale: 1,
  },
  hover: {
    scale: 1.1,
    transition: { type: 'spring', stiffness: 100 },
  },
});

class DayTile extends React.Component<IDayTileProps & IMPComponent> {
  public static defaultProps = {
    actualWordsCount: 0,
    isCurrent: false,
    isPast: false,
    isSelected: false,
  };

  public render() {
    const {
      className,
      style,
      day,
      expectedWordsCount,
      actualWordsCount,
      isCurrent,
      isPast,
      isSelected,
      isStreakRepaired,
      modifiers,
    } = this.props;

    const cn = classNames('DayTile', className, {
      'DayTile--current': isCurrent,
      'DayTile--selected': isSelected,
      'DayTile--past': isPast,
      'DayTile--streakRepaired': isStreakRepaired,
      ...modifiers,
    });

    let progress = ((actualWordsCount as number) / expectedWordsCount) * 100;

    progress = progress > 0 ? Math.max(COMMON_CONSTANTS.MIN_WRITE_PROGRESS, progress) : progress;

    const initialHeight = (100 / progress) * 100;
    return (
      <Box>
        <button className={cn} style={style} onClick={this.handleClick} tabIndex={0}>
          <div className="DayTile-score DayTile-score--target">{day}</div>
          <div className="DayTile-score DayTile-score--actual" style={{ height: `${progress}%` }}>
            <div className="DayTile-scoreInner" style={{ height: `${initialHeight}%` }}>
              {day}
            </div>
          </div>
        </button>
      </Box>
    );
  }

  private handleClick = (event: React.MouseEvent) => {
    const { onClick, value } = this.props;

    if (isFunction(onClick)) {
      onClick(value);
    }
  };
}

export default DayTile;



// WEBPACK FOOTER //
// ./src/components/DayTile/index.tsx